import { ReactNode } from "react";
import { useScrollProgress } from "@/hooks/useScrollProgress";
import { cn } from "@/lib/utils";

interface ParallaxLayerProps {
  children: ReactNode;
  /** -1 to 1; positive moves slower than scroll, negative inverts. */
  speed?: number;
  className?: string;
}

/**
 * Translates its children on the Y axis based on scroll position.
 * Use behind hero / aurora / constellation layers for depth.
 */
export function ParallaxLayer({ children, speed = 0.25, className }: ParallaxLayerProps) {
  const [ref, progress] = useScrollProgress<HTMLDivElement>();
  const offset = (progress - 0.5) * 80 * speed; // px

  return (
    <div
      ref={ref}
      className={cn("will-change-transform", className)}
      style={{ transform: `translate3d(0, ${offset}px, 0)` }}
    >
      {children}
    </div>
  );
}
